// This file contains build-time information
// The BUILD_TIMESTAMP is set at build time and represents when the app was last published

export const BUILD_TIMESTAMP = new Date().toISOString();
